module.exports = __webpack_public_path__ + "img/logo-signup-promo.60322b56.svg";